/**
 * Route guard. While `/api/me` is in flight we show a centered spinner; once
 * resolved, an authenticated session renders the children, otherwise we
 * `<Navigate>` to `/login` (preserving the attempted path in router state so a
 * future post-login redirect can honour it).
 */
import { Spinner } from '@evt/flow-stream-ui'
import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useSession } from './useSession'

export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, loading } = useSession()
  const location = useLocation()

  if (loading) {
    return (
      <div className="portal-center">
        <Spinner size={20} />
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  return <>{children}</>
}
